import React from 'react'

import FirstSection from '../Packages/FirstSection'
import SecondSection from '../Packages/SecondSection'

import ColorPallet from '../../../utils/ColorPallet' 

function MainSection() {
  return (
    <div className="min-h-screen">
      {/* First Section */}
        <FirstSection />
      
      {/* Second Section */}
        <div style={{ backgroundColor: ColorPallet.primaryLightBrown }}>
        <SecondSection />
      </div>
      
    </div>
  )
}

export default MainSection